export default function pickClass (classes) {
  for (const c in classes) {
    if (c !== 'default' && classes[c]) {
      return c
    }
  }
  return classes.default || 'default'
}
